export default __webpack_public_path__ + "static/media/skulls-2.e7ebfa7d.png";